import { BiPixel, TagManager } from '@derstandard/tracking';
import { v4 as UUIDv4 } from '@lukeed/uuid';

import { log } from '@/lib/log';
import { userHasPur } from '@/lib/util';

const biPixel = new BiPixel({
	pixelUrl: import.meta.env.VITE_APP_BI_PIXEL_URL,
	receiverUrl: import.meta.env.VITE_APP_BI_RECEIVER_URL,
	environment: import.meta.env.VITE_APP_ENVIRONMENT as 'development' | 'production',
	initialize: true
});

/**
 * Initializes TagManager instance
 * @returns {Class}
 */
export function initTagManager() {
	return new TagManager({
		trackingId: import.meta.env.VITE_APP_GOOGLE_TAG_MANAGER_ID,
		scriptUrl: import.meta.env.VITE_APP_GOOGLE_TAG_MANAGER_URL
	});
}

/**
 * Sends bundle_reference to dataLayer
 */
export function sendBundleReference() {
	const tagManager = initTagManager();
	const sessionData = sessionStorage.getItem('sessionData');
	let sessionDataParsed;

	if (sessionData) {
		sessionDataParsed = JSON.parse(sessionData);
	}

	if (sessionDataParsed?.bundle?.bundleReference) {
		tagManager.pushToDataLayer({
			bundle_reference: sessionDataParsed.bundle.bundleReference
		});
	}

	log('Pushed to dataLayer', window.dataLayer);
}

/**
 * Aggregated tracking of custom events
 */
export async function trackUserAction() {
	const correlationId = UUIDv4();
	const hasPur = await userHasPur();

	biPixel.sendPageImpression({
		correlationid: correlationId
	});

	if (!hasPur) {
		sendBundleReference();
	}
}
